import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import InlineSVG from "ComponentsUI/Inlinesvg";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			height: "100%",
			borderRadius: "10px",
			textAlign: "center",
			cursor: "pointer",
			position: "relative",
			overflow: "hidden",
			zIndex: "0",
		},
		logo: {
			fill: theme.palette.colors.disabled,
			"& svg": {
				height: "24px",
				width: "24px",
			},
			"& path": {
				fill: theme.palette.colors.disabled,
			},
		},
		image: {
			height: "24px",
			width: "24px",
		},
		text: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			textAlign: "center",
			color: theme.palette.colors.darkSlateBlue2,
			marginTop: "8px",
		},
		positive: {
			color: "#23c4a0",
			marginRight: "-1px",
			fontFamily: theme.fonts.bold,
		},
		neutral: {
			color: theme.palette.colors.cloudyBlue,
			marginRight: "-1px",
			fontFamily: theme.fonts.bold,
		},
		negative: {
			color: "#ff587a",
			marginRight: "-1px",
			fontFamily: theme.fonts.bold,
		},
		orange: {
			color: "#f7671c",
			marginRight: "-1px",
			fontFamily: theme.fonts.bold,
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				borderRadius: 0,
				border: "none",
				textAlign: "center",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				borderRadius: 0,
				border: "none",
				textAlign: "center",
				overflow: "visible",
			},
			logo: {
				width: "20px",
				height: "20px",
			},
			image: {
				width: "20px",
				height: "20px",
			},
			text: {
				fontSize: "12px",
			},
		},
	};
};

const RatingSpec = ({ classes, logo, image, positive, neutral, negative, orange, text }) => (
	<div className={classes.root}>
		{logo && (
			<InlineSVG src={logo} className={classes.logo}>
				<svg width="24" height="20">
					<image xlinkHref={logo} width="24" height="20" />
				</svg>
			</InlineSVG>
		)}
		{image && <img alt={"image"} src={image} className={classes.image} />}
		<div
			className={classNames(classes.text, {
				[classes.positive]: positive,
				[classes.neutral]: neutral,
				[classes.negative]: negative,
				[classes.orange]: orange,
			})}
		>
			{text}
		</div>
	</div>
);

RatingSpec.defaultProps = {
	classes: {},
	image: "",
	logo: "",
	text: "",
	progress: 0,
	positive: false,
	neutral: false,
	negative: false,
	orange: false,
};

export default withStyles(styles)(RatingSpec);

export { RatingSpec as __RatingSpec };
